const TransactionTabs = {
    TRANSACTION_HISTORY : "TRANSACTION_HISTORY",
    IMPORT_TRANSACTIONS : "IMPORT_TRANSACTIONS",
    INVALID_TRANSACTIONS : "INVALID_TRANSACTIONS",
    ANOMALY_TRANSACTIONS : "ANOMALY_TRANSACTIONS"
}

export default TransactionTabs;